import CheckboxGroupInput, { CheckboxGroupInputProps } from '../inputs/checkbox-group.input'
import FieldSet from './field-set'
import { FormFieldProps } from './types'
import { onBlurHandler, onChangeHandler, useRemoveFieldOnUnmount } from './utils'

export type CheckboxGroupFieldProps<T = string> = CheckboxGroupInputProps & FormFieldProps<T>

const CheckboxGroupField = ({
  form,
  name,
  wrapperClassName,
  labelClassName,
  descriptionClassName,
  validators,
  isArrayField,
  arrayFieldName,
  arrayFieldIndex,
  defaultValue,
  label,
  description,
  onChange,
  onBlur,
  removeFieldOnUnmount,
  ...rest
}: CheckboxGroupFieldProps) => {
  useRemoveFieldOnUnmount(form, name, removeFieldOnUnmount)

  return (
    <FieldSet
      name={name}
      form={form}
      wrapperClassName={wrapperClassName}
      labelClassName={labelClassName}
      descriptionClassName={descriptionClassName}
      arrayFieldIndex={arrayFieldIndex}
      arrayFieldName={arrayFieldName}
      isArrayField={isArrayField}
      {...rest}
    >
      {(hasErrors) => (
        <form.Field name={name} defaultValue={defaultValue} validators={validators}>
          {(field: any) => (
            <CheckboxGroupInput
              {...rest}
              name={name}
              label={label}
              description={description}
              value={field.state.value}
              onBlur={onBlurHandler(field, onBlur)}
              onChange={onChangeHandler(field, onChange)}
              hasErrors={hasErrors}
            />
          )}
        </form.Field>
      )}
    </FieldSet>
  )
}

export default CheckboxGroupField
